module.exports = __webpack_public_path__ + "img/pirates.62c81f32.png";